/* eslint-disable no-empty-pattern */
import React from "react"
import KudaAppBadge from "../../assets/img/kuda-business-app-badge.inline.svg"
import KudaAppStars from "../../assets/img/kuda-app-stars.inline.svg"
import { MobileStyled } from "./mobile-styles"

const GetBusinessMobile = () => {

  return (
    <MobileStyled>
      <div className="kuda-mobile--get kuda-dark--bg">
        <div className="Kuda-ratings flex align-center justify-between column--100">
          <div className="flex align-center">
            <div className="kuda-app--badge">
              <KudaAppBadge />
            </div>
            <div className="kuda-app--stars">
              <p className="kuda-app--name card-main--heading no-margin--bottom text-xbold color-white">
                Kuda Business
              </p>
              <div className="kuda-star--wrap">
                <KudaAppStars />
              </div>
            </div>
          </div>
          <a
            href={"https://kudabusiness.onelink.me/epwz/89t3xxwm"}
            className="kuda-cta kuda_web kuda-cta-dark"
            rel="noopener noreferrer"
            target="_blank"
          >
            Open an account
          </a>
        </div>
      </div>
    </MobileStyled>
  )
}
export default GetBusinessMobile
